export const graphqlBaseUrl = "https://api-renai.thetokenlist.com/graphql/nft-middleware/users";
